import classNames from 'classnames'
import { observer } from 'mobx-react'
import { useEffect, useState } from 'react'
import {
  getExpectedSeconds,
  getExpectedSecondsVariables,
  getExpectedSeconds_pictureGraph_aiArtworkTotalInfo_expectedSeconds,
} from '~/graphqls/types'
import styles from '../AiForm.module.css'
import { timeWithUint, toHm } from '~/utils'
import { Tooltip } from 'antd'
import { QuestionCircleOutlined } from '@ant-design/icons'
import {
  genNightAtom,
  modelCodeAtom,
  paintTimesAtom,
  totalInfoAtom,
} from './atom'
import { useAtom } from 'jotai'
import { useImperativeQuery } from '~/hooks/useImperativeQuery'
import { GET_EXPECTED_SECONDS } from '~/graphqls/gqls'

export const GenerationComp = observer(() => {
  const [paintTimes] = useAtom(paintTimesAtom)
  const [totalInfo] = useAtom(totalInfoAtom)
  const [genNight, setGenNight] = useAtom(genNightAtom)
  const [modelCode] = useAtom(modelCodeAtom)

  const getExpectedSecondsAction = useImperativeQuery<
    getExpectedSeconds,
    getExpectedSecondsVariables
  >(GET_EXPECTED_SECONDS)

  /** 预计时间 */
  const [expectedSeconds, setExpectedSeconds] =
    useState<getExpectedSeconds_pictureGraph_aiArtworkTotalInfo_expectedSeconds>(
      totalInfo?.expectedSeconds!
    )

  const onRefreshExpecteds = () => {
    getExpectedSecondsAction({
      modelCode: modelCode,
    })
      .then(res => {
        if (res.data.pictureGraph?.aiArtworkTotalInfo.expectedSeconds) {
          setExpectedSeconds(
            res.data.pictureGraph?.aiArtworkTotalInfo.expectedSeconds
          )
        }
      })
      .catch(() => {})
  }

  useEffect(() => {
    if (!!modelCode) {
      onRefreshExpecteds()
    }
  }, [modelCode])

  return (
    <div>
      <div
        className={classNames(
          'flex items-center justify-between cursor-pointer px-4 py-5 border-2 border-solid border-neutral-200 rounded-2xl duration-75 bg-neutral-200',
          {
            '!border-neutral-500': !genNight,
            [styles.radialBg]: !genNight,
          }
        )}
        onClick={() => setGenNight(false)}
      >
        <div className="flex items-center">
          <span className="text-neutral-800 text-sm font-medium">普通生成</span>
        </div>
        <div className="text-neutral-500 text-xs">
          预计排队：
          {timeWithUint(
            expectedSeconds?.freeExpectedSeconds +
              expectedSeconds.reduceTime * (paintTimes - 1)
          )}
        </div>
      </div>
      <div
        className={classNames(
          'mt-4  cursor-pointer px-4 py-5 border-2 border-solid border-neutral-200 rounded-2xl duration-75 bg-neutral-200',
          {
            '!border-neutral-500': genNight,
            [styles.radialBg]: genNight,
          }
        )}
        onClick={() => setGenNight(true)}
      >
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <span className="text-neutral-800 text-sm font-medium">
              夜间生成{' '}
              <Tooltip
                placement="topLeft"
                arrowPointAtCenter
                title={
                  <>
                    使用夜间（02:00~06:00）闲置云计算资源进行创作可享受生成优惠；
                    <br />
                    开启夜间生成，创作将按发起顺序依次生成，会员享有优先生成的权益；
                    <br />
                    夜间未生成的创作会在下一个夜间优先生成。
                  </>
                }
              >
                <QuestionCircleOutlined />
              </Tooltip>
            </span>
          </div>
          <div className="text-neutral-500 text-xs">
            优惠低至五折，预计将在{' '}
            {toHm(
              expectedSeconds?.nightExpectedTime +
                expectedSeconds?.reduceTime * (paintTimes - 1)
            )}{' '}
            生成
          </div>
        </div>
      </div>
    </div>
  )
})
